import { findVariableTokens } from '../../utils/monacoLargeText';

/**
 * The `{{var}}` tokens to mark: the whole model for a normal text, only what is
 * on screen for a large one — never a 10 MB `getValue()` per keystroke.
 */
export function variableTokensOf(editor, model, large) {
  if (!large) return findVariableTokens(model.getValue());
  return visibleTextWindows(editor, model).flatMap((w) => findVariableTokens(w.text, w.offset));
}

/**
 * The parts of a Monaco model that are on screen, with `margin` lines either
 * side, as text plus the model offset it starts at. A large body's `{{var}}`
 * highlighting scans these instead of the whole 10 MB (see CodeEditor).
 */
export function visibleTextWindows(editor, model, margin = 50) {
  const ranges = (editor.getVisibleRanges?.() || [])
    .map((r) => ({ start: r.startLineNumber, end: r.endLineNumber }))
    .sort((a, b) => a.start - b.start);
  const lineCount = model.getLineCount();
  const merged = [];
  for (const r of ranges) {
    const start = Math.max(1, r.start - margin);
    const end = Math.min(lineCount, r.end + margin);
    const last = merged[merged.length - 1];
    if (last && start <= last.end + 1) last.end = Math.max(last.end, end);
    else merged.push({ start, end });
  }
  return merged.map(({ start, end }) => ({
    offset: model.getOffsetAt({ lineNumber: start, column: 1 }),
    text: model.getValueInRange({
      startLineNumber: start, startColumn: 1, endLineNumber: end, endColumn: model.getLineMaxColumn(end),
    }),
  }));
}
